module.exports = __webpack_public_path__ + "img/1547207458.fc432bfb.jpg";